import styled from "styled-components";
import { Spinner } from "styles/components";
import { Button, Select } from "styles/elements";
import { FlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

export const MembersContainer = styled(FlexColumn)`
  padding: ${Theme.bigPanelPadding};
  row-gap: 5px;
  @media (max-width: 700px) {
    padding: ${Theme.smallPanelPadding};
  }
  overflow: auto;
`;

export const MemberActionButton = styled(Button)`
  @media (max-width: 600px) {
    font-size: 9pt;
    padding: 2px;
  }
`;

export const Username = styled.div`
  font-weight: 500;
  width: 200px;
  padding-right: 5px;

  span {
    max-width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: clip;
  }

  @media (max-width: 600px) {
    width: 120px;
    span {
      max-width: 120px;
    }
    font-size: 10pt;
  }

  @media (max-width: 400px) {
    width: 100px;
    span {
      max-width: 100px;
    }
    font-size: 9.5pt;
  }
`;

export const UserType = styled.div`
  width: 100px;
  padding-right: 4px;
  @media (max-width: 600px) {
    width: 70px;
    font-size: 10pt;
  }
  @media (max-width: 400px) {
    display: none;
  }
`;

export const ActionInProgressSpinner = styled(Spinner)`
  border-width: ${Theme.spinnerSmallBorderWidth};
  width: 14px;
  height: 14px;
  margin: auto;
`;

export const GroupActionsContainer = styled(FlexRow)``;

export const JoinTypeContainer = styled(FlexRow)`
  margin-right: auto;
`;

export const JoinTypeText = styled.div`
  line-height: 100%;
  padding: 0 5px 0 2px;
  font-size: 12pt;
  font-weight: 500;

  @media (max-width: 600px) {
    font-size: 11pt;
    padding-left: 4px;
  }
`;
export const JoinTypeSelect = styled(Select)`
  margin-right: 4px;
  width: 100px;
  padding: 4px 4px 4px 1px;
`;
